import { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { DangerAlert, Table, WaitingAlert } from '@tmapy/style-guide';
import { QUERY_STATE } from '@tmapy/beetlejuice-utils';

import { useGraphDataResource } from './useChartDataResource';

const msg = defineMessages<any>({
  subjektTitle: {
    id: 'chart.subjekt.title',
    defaultMessage: 'Počty žádostí o data dle subjektu',
  },
  subjektID: {
    id: 'chart.subjekt.id',
    defaultMessage: 'ID',
  },
  subjektNazev: {
    id: 'chart.subjekt.nazev',
    defaultMessage: 'Název',
  },
  subjektCount: {
    id: 'chart.subjekt.count',
    defaultMessage: 'Počet',
  },
  queryStateWaiting: {
    id: 'chart.subjekt.queryStateWaiting',
    defaultMessage: 'Načítám statistická data "subjekt" - Čekejte prosím...',
  },
  queryStateFail: {
    id: 'chart.subjekt.queryStateFail',
    defaultMessage: 'Načtení statistických dat "subjekt" selhalo.',
  },
});

type DataItem = {
  id_subjektu: string;
  jmeno?: string;
  prijmeni?: string;
  nazev?: string;
  url?: string;
  order_count: number;
};

export const SubjektCountTable = () => {
  const [queryState, setQueryState] = useState<QUERY_STATE>(QUERY_STATE.EMPTY);

  const resource = useGraphDataResource({ graph_type: 'subjekt_order_count' });
  const data = useMemo<DataItem[] | undefined>(() => {
    setQueryState(resource.queryState);
    if (resource.queryState !== QUERY_STATE.SUCCESS) return;

    // statistika top 10.
    return resource.data?.results.slice(0, 10) as DataItem[];
  }, [resource.data]);

  return (
    <>
      {queryState === QUERY_STATE.WAITING && (
        <WaitingAlert>
          <FormattedMessage {...msg.queryStateWaiting} />
        </WaitingAlert>
      )}
      {queryState === QUERY_STATE.FAIL && (
        <DangerAlert>
          <FormattedMessage {...msg.queryStateFail} />
        </DangerAlert>
      )}

      {data && (
        <div className='sg-u-vs-4'>
          <section>
            <h3 className='sg-u-type-h2 sg-a-ml-2'>
              <FormattedMessage {...msg.subjektTitle} />
            </h3>
            <div className='sg-u-box sg-a-mt-1 dmx-a-mw-fc'>
              <Table>
                <thead>
                  <tr>
                    <th>
                      <FormattedMessage {...msg.subjektID} />
                    </th>
                    <th>
                      <FormattedMessage {...msg.subjektNazev} />
                    </th>
                    <th>
                      <FormattedMessage {...msg.subjektCount} />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item: DataItem, idx: number) => (
                    <DataItem key={idx} {...item} />
                  ))}
                </tbody>
              </Table>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

const DataItem = (props: DataItem) => {
  return (
    <tr>
      <td>{props.id_subjektu}</td>
      <td>{`${props.nazev} (${props.jmeno} ${props.prijmeni})`}</td>
      <td className='sg-u-c-body-darkest'>
        <pre>{props.order_count}</pre>
      </td>
    </tr>
  );
};
